import {useTranslation} from '@/translations/i18n'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {StyledHistoryList, StyledIssueCard, StyledIssueRowMain, StyledIssueRowRight, StyledSkeletonRow} from './style'

/* Varied title widths so the placeholder reads as a list of distinct issues rather than a stack of identical bars. */
const SKELETON_TITLE_WIDTHS = [220, 170, 250, 190]

export const BugReportHistorySkeleton = () => {
    const {t} = useTranslation()

    return (
        <StyledHistoryList role="status" aria-label={t('bug_reporter:history_loading')}>
            {SKELETON_TITLE_WIDTHS.map((titleWidth, index) => (
                <StyledIssueCard key={index}>
                    <StyledSkeletonRow>
                        <StyledIssueRowMain>
                            <Skeleton width={titleWidth} height={14} />
                            <Skeleton width={140} height={12} />
                        </StyledIssueRowMain>
                        <StyledIssueRowRight>
                            <Skeleton width={20} height={20} style={{borderRadius: '50%'}} />
                            <Skeleton width={72} height={12} />
                            <Skeleton width={16} height={16} />
                        </StyledIssueRowRight>
                    </StyledSkeletonRow>
                </StyledIssueCard>
            ))}
        </StyledHistoryList>
    )
}
